// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".meeting-documents{border-bottom:1px solid #ddd}", "",{"version":3,"sources":["webpack://./app/scripts/vue/committees/MeetingDocuments.vue"],"names":[],"mappings":"AACA,mBACI,4BAAJ","sourcesContent":["\n.meeting-documents {\n    border-bottom: 1px solid #dddddd;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
